'use client';

import Page from '@organisms/Page/Page';
import useCmsPage from '@hooks/useCmsPage';

interface Props {
  label: string;
}

export default function StorePageClient({ label }: Props) {
  const { cmsPage } = useCmsPage(label);

  return <Page cmsPage={cmsPage} />;
}
